import { CardUIExtension, ICardUIExtensionContext } from 'tessa/ui/cards';
import { Guid, DotNetType, createTypedField } from 'tessa/platform';
import { GridViewModel } from 'tessa/ui/cards/controls';
import { openCard, showViewsDialog } from 'tessa/ui/uiHost';
import { IStorage } from 'tessa/platform/storage';
import { CardRow, CardRowState } from 'tessa/cards';
import { CdCardTypes } from '../Helpers/CdCardTypes';

export class CdTableUIExtension extends CardUIExtension {

    private _disposer: Function | null = null;

  public initialized(context: ICardUIExtensionContext) {
    if (context.model == null ||
        context.model.card == null) {
      return;
    }
    if (!(
        Guid.equals(context.model.card.typeId, CdCardTypes.ArDocumentIdpTypeID)
    )) {
        return;
    }
    // Документ ИДП
    let adipSection = context.model.card.sections.tryGet('ArDocumentsIDPPartners');
    if (adipSection != null) {
        let refsTable = context.model.controls.get('DocumentsIDPPartners') as GridViewModel;
        if (refsTable != null) {
            refsTable.rowInitializing.add(async e => {
                let partnerExternalID = e.row.get("PartnerExternalID");
                const infoDict: IStorage = {
                    'ExternalID': createTypedField(partnerExternalID, DotNetType.Int64)
                };
                await openCard({
                    cardId: Guid.newGuid(),
                    cardTypeId: CdCardTypes.PkKCKPartnerTypeID,
                    info: infoDict
                });
                e.cancel = true;
                return;
            });
            refsTable.rowAdding.add(async e => {
                if (adipSection == null) return;
                await showViewsDialog(
                    'PkKCKPartners',
                    async (value) => {
                        if (!value) {
                            return;
                        }
                        let selectedItem = value;

                        if (selectedItem == null
                            || !selectedItem.selectedRow
                            || !adipSection) {
                            e.cancel = true;
                            return;
                        }
        
                        let row = new CardRow();
                        row.rowId = Guid.newGuid();
                        let category = selectedItem.selectedRow.get("PartnerCategory");
                        if (category == null) row.set("Category", null);
                        else row.set("Category", createTypedField(category, DotNetType.String));
                        let inn = selectedItem.selectedRow.get("PartnerINN");
                        if (inn == null) row.set("INN", null);
                        else row.set("INN", createTypedField(inn, DotNetType.String));
                        row.set("IsVirtual", createTypedField(false, DotNetType.Boolean));
                        let partner = selectedItem.selectedRow.get("PartnerName");
                        if (partner == null) row.set("Partner", null);
                        else row.set("Partner", createTypedField(partner, DotNetType.String));
                        let partnerExternalID = selectedItem.selectedRow.get("PartnerExternalID");
                        if (partnerExternalID == null) row.set("PartnerExternalID", null);
                        else row.set("PartnerExternalID", createTypedField(partnerExternalID, DotNetType.Int64));
                        let partnerFullName = selectedItem.selectedRow.get("PartnerFullName");
                        if (partnerFullName == null) row.set("PartnerFullName", null);
                        else row.set("PartnerFullName", createTypedField(partnerFullName, DotNetType.String));
                        let partnerID = selectedItem.selectedRow.get("PartnerID");
                        if (partnerID == null) row.set("PartnerID", null);
                        else row.set("PartnerID", createTypedField(partnerID, DotNetType.Guid));
                        let partnerINN = selectedItem.selectedRow.get("PartnerINN");
                        if (partnerINN == null) row.set("PartnerINN", null);
                        else row.set("PartnerINN", createTypedField(partnerINN, DotNetType.String));
        
                        row.state = CardRowState.Inserted;
                        adipSection.rows.push(row);
        
                        e.cancel = true;
                    }
                );
            });
        }
    }
  }

  public finalized() {
      // подчищаем за собой
      if (this._disposer) {
          this._disposer();
          this._disposer = null;
      }
  }
}